import React, { createContext, useContext, useState, useCallback } from "react";
import './toastnew.css'
const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = "info", duration = 3000) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, duration);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="toast-container" style={{ position: 'fixed', bottom: '20px', right: '1%',   zIndex: 9999, width: 'fit-content', maxWidth: '90%' }}>
        {toasts.map((toast) => (
          <div key={toast.id} className={`toast show toast--${toast.type}`}>
            <span className="toast__icon">
              {toast.type === "success" && (
                <svg viewBox="0 0 24 24">
                  <path
                    d="M7 13.5l3 3 7-7"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </svg>
              )}
              {toast.type === "error" && (
                <svg viewBox="0 0 24 24">
                  <path
                    d="M8 8l8 8M16 8l-8 8"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </svg>
              )}
              {toast.type === "info" && (
                <svg viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="1.3" fill="currentColor" />
                  <path
                    d="M12 8v2.5"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    fill="none"
                  />
                </svg>
              )}
            </span>
            <span>{toast.message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);